$( function() {
	$uploadform = $('form[name=upload]');

	function uploadFiles(files) {

		var url = $uploadform.attr('action');
		var formData = new FormData();
		var hasData = false;
		for (var i = 0; i < files.length; i++) {
			var file = files[i];
			if (file.type != "image/jpeg" && file.type != "image/png") {
				uploadLog('error', file.name + ' ist keine gültige JPG- oder PNG-Datei.');
				continue;
			}
			if (file.size > (1024 * 1024 * 5) ) {
				uploadLog('error', file.name + ' ist größer als 5 MB.');
				continue;
			}
			formData.append('images[]', file, file.name);
			hasData = true;
		}

		if(!hasData) {
			return false;
		}

		$.ajax({
			url: url,
			data: formData,
			processData: false,
			contentType: false,
			type: 'POST',
			success: function ( res ) {
				if( res.infos ) {
					$.each(res.infos, function(i, msg) {
						uploadLog('info', msg);
					});
					$('.profile').find('ul.gallery').trigger('imagesupdate');
				}
				if( res.error ) {
					$.each(res.errors, function(i, msg) {
						uploadLog('error', msg);
					});
				}
				$uploadform.get(0).reset();
			}
		});
	}

	$uploadform.find('input[type=file]').on('change', function(e) {
		e.preventDefault();
		var files = $(this).get(0).files;
		uploadFiles(files);
	});

	$('#dropzone').on('drop', function(e) {
		e.preventDefault();
		if(e.originalEvent.dataTransfer) {
			if(e.originalEvent.dataTransfer.files.length) {
				uploadFiles(e.originalEvent.dataTransfer.files);
			}
		}
	});

	$('.profile').on('click', '.cta .btn', function(e) {
		if($(this).hasClass('vote')) {
			return true;
		}
		e.preventDefault();
		$uploadform.find('input[type=file]').trigger('click');
	});

	$('#dropzone').on('click', function(e) {
		if(e.target.nodeName != 'A') {
			e.preventDefault();
			$uploadform.find('input[type=file]').trigger('click');
		}
	});

	function uploadLog(type, msg) {
		$msg = $('<li class="'+type+'">'+msg+'</li>');
		$msg.hide().appendTo('ul.log.upload').fadeIn();
	}

	$("html").on("dragover", function(e) {
		e.preventDefault();
		e.stopPropagation();
	});

	$("html").on("dragleave", function(e) {
		e.preventDefault();
		e.stopPropagation();
	});

	$("html").on("drop", function(e) {
		e.preventDefault();
		e.stopPropagation();
	});
});